"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("../context/ModalContext");
const textUtil_1 = require("../common/textUtil");
const ModalFooter = (props) => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const apply = () => {
        var _a, _b;
        (0, textUtil_1.setTargetText)(context.target, (_b = (_a = (0, textUtil_1.getCurrentResponse)(context.responses, context.showResponseIndex)) === null || _a === void 0 ? void 0 : _a.answer) !== null && _b !== void 0 ? _b : '');
        props.close();
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "modal-footer", children: (0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-xs-5 col-xs-offset-7", children: [(0, jsx_runtime_1.jsx)("button", { value: "Prov\u00E9st", className: "btn btn-primary", onClick: apply, disabled: !context.responses.length, children: "Pou\u017E\u00EDt" }), (0, jsx_runtime_1.jsx)("button", { value: "Zav\u0159\u00EDt", className: "btn btn-secondary", onClick: props.close, children: "Zav\u0159\u00EDt" })] }) }) }));
};
exports.ModalFooter = ModalFooter;
